import $ from "jquery";
import backButton from "./backButton";

export default function () {
    if (!$('body').hasClass('warranty-confirmation')) {
        return false;
    }

    backButton();
}
